import { usePage } from '@inertiajs/react'
import { executionPath, workflowPath } from '@/frontend/pages/Dashboard/Workflows/presentation'
import type { ExecutionMetadata } from '@/frontend/pages/Dashboard/Workflows/types'

/** One route builder keeps project context across the existing Praxis pages. */
export default function useWorkflowNavigation() {
  const { props } = usePage<{ project?: { id: string; name: string } }>()
  const projectId = props.project?.id
  const scoped = (path: string) => {
    if (!projectId) return path
    const [pathname, query = ''] = path.split('?')
    const params = new URLSearchParams(query)
    params.set('project_id', projectId)
    return `${pathname}?${params}`
  }
  return {
    projectId,
    rootPath: scoped('/dashboard/workflows'),
    connectionPath: scoped('/dashboard/workflows/connection'),
    workflowPath: (workflow: string) => scoped(workflowPath(workflow)),
    executionPath: (execution: ExecutionMetadata) => scoped(executionPath(execution)),
    lookupPath: (id: string) => scoped(`/dashboard/workflows/executions/${encodeURIComponent(id)}`),
    recentExecutionsPath: (workflow: string, query: URLSearchParams) => scoped(`${workflowPath(workflow)}/recent_executions?${query}`),
  }
}
